<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container>
            <v-expansion-panels
                    :accordion="accordion"
                    :inset="inset"
                    :multiple="multiple"
                    :focusable="focusable"
                    :disabled="disabled"
                    :readonly="readonly"
                    :flat="flat"
                    :hover="hover"
                    :tile="tile"
                    v-model="panel"
            >
                <v-text-field v-if="generals==undefined" color="primary" loading disabled></v-text-field>
                <v-expansion-panel>
                    <v-expansion-panel-header style="color: #29B3A6;font-weight: bold">
                        {{$t('generalsetting.amountSetting')}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>

                        <ul>
                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.mminr')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-text-field type="number" min="1" v-model="generalsettings.mminr"
                                                      :label="$t('value')" single-line solo></v-text-field>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.mmaxr')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-text-field type="number" min="1" v-model="generalsettings.mmaxr"
                                                      :label="$t('value')" single-line solo></v-text-field>
                                    </v-col>
                                </v-row>
                            </li>


                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.mmint')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-text-field type="number" min="1" v-model="generalsettings.mmint"
                                                      :label="$t('value')" single-line solo></v-text-field>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.mmaxt')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-text-field type="number" min="1" v-model="generalsettings.mmaxt"
                                                      :label="$t('value')" single-line solo></v-text-field>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.mmintr')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-text-field type="number" min="1" v-model="generalsettings.mmintr"
                                                      :label="$t('value')" single-line solo></v-text-field>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.mmaxtr')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-text-field type="number" min="1" v-model="generalsettings.mmaxtr"
                                                      :label="$t('value')" single-line solo></v-text-field>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.mminrch')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-text-field type="number" min="1" v-model="generalsettings.mminrch"
                                                      :label="$t('value')" single-line solo></v-text-field>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.mmaxrch')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-text-field type="number" min="1" v-model="generalsettings.mmaxrch"
                                                      :label="$t('value')" single-line solo></v-text-field>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.tt')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-text-field type="number" min="1" max="100" v-model="generalsettings.tt"
                                                      :label="$t('value')" single-line solo></v-text-field>
                                    </v-col>
                                </v-row>
                            </li>


                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.dda')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-select :items="devises" item-text='_code_alpha' item-value="_id"
                                                  return-object v-model="generalsettings.dda" solo></v-select>
                                    </v-col>
                                </v-row>
                            </li>


                        </ul>

                        <v-row>
                            <v-spacer></v-spacer>


                            <v-btn :disbled="submitting4" style="margin-right: 2%" color="primary"
                                   @click.prevent="save(4)">

                                <span v-if='!submitting4'>{{$t('save')}} </span>
                                <span v-else><v-progress-circular
                                        :width="1"
                                        color="white"
                                        indeterminate
                                        :size="25"
                                ></v-progress-circular> {{$t('saving')}} </span>

                            </v-btn>
                        </v-row>

                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-header style="color: #29B3A6;font-weight: bold">
                        {{$t('generalsetting.password')}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>

                        <ul>
                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.rapwf')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-switch v-model="generalsettings.rapwf"
                                                  :label="generalsettings.rapwf?'ON':'OFF'"></v-switch>
                                    </v-col>
                                </v-row>
                            </li>


                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.nevc')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <integer-plusminus
                                                min="1"
                                                v-model="generalsettings.nevc">

                                            {{ generalsettings.nevc }}

                                            <template slot="decrement">
                                                <v-icon color="primary">mdi-minus-circle</v-icon>
                                            </template>

                                            <template slot="increment">
                                                <v-icon color="primary">mdi-plus-circle</v-icon>
                                            </template>
                                        </integer-plusminus>

                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0%;">
                                        <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.nmcpw')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <integer-plusminus
                                                min="1"
                                                v-model="generalsettings.nmcpw">

                                            {{ generalsettings.nmcpw }}

                                            <template slot="decrement">
                                                <v-icon color="primary">mdi-minus-circle</v-icon>
                                            </template>

                                            <template slot="increment">
                                                <v-icon color="primary">mdi-plus-circle</v-icon>
                                            </template>
                                        </integer-plusminus>

                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.aucpw')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-switch v-model="generalsettings.aucpw"
                                                  :label="generalsettings.aucpw?'ON':'OFF'"></v-switch>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.erpw')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-switch v-model="generalsettings.erpw"
                                                  :label="generalsettings.erpw?'ON':'OFF'"></v-switch>
                                    </v-col>
                                </v-row>
                            </li>

                        </ul>

                        <v-row>
                            <v-spacer></v-spacer>


                            <v-btn :disbled="submitting" style="margin-right: 2%" color="primary"
                                   @click.prevent="save(1)">

                                <span v-if='!submitting'>{{$t('save')}} </span>
                                <span v-else><v-progress-circular
                                        :width="1"
                                        color="white"
                                        indeterminate
                                        :size="25"
                                ></v-progress-circular> {{$t('saving')}} </span>

                            </v-btn>
                        </v-row>

                    </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- -->

                <v-expansion-panel>
                    <v-expansion-panel-header style="color: #29B3A6;font-weight: bold">{{$t('generalsetting.means')}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <ul>
                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.dpm')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-switch v-model="generalsettings.dpm"
                                                  :label="generalsettings.dpm?'ON':'OFF'"></v-switch>
                                    </v-col>
                                </v-row>
                            </li>
                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.dpb')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0; padding: 0;">
                                        <v-switch v-model="generalsettings.dpb"
                                                  :label="generalsettings.dpb?'ON':'OFF'"></v-switch>
                                    </v-col>
                                </v-row>
                            </li>
                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span> {{$t('generalsetting.dpqr')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0; padding: 0;">
                                        <v-switch v-model="generalsettings.dpqr"
                                                  :label="generalsettings.dpqr?'ON':'OFF'"></v-switch>
                                    </v-col>
                                </v-row>
                            </li>


                        </ul>

                        <v-row>
                            <v-spacer></v-spacer>


                            <v-btn :disbled="submitting" style="margin-right: 2%" color="primary"
                                   @click.prevent="save(1)">

                                <span v-if='!submitting'>{{$t('save')}} </span>
                                <span v-else><v-progress-circular
                                        :width="1"
                                        color="white"
                                        indeterminate
                                        :size="25"
                                ></v-progress-circular> {{$t('saving')}} </span>

                            </v-btn>
                        </v-row>

                    </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- -->
                <v-expansion-panel>
                    <v-expansion-panel-header style="color: #29B3A6;font-weight: bold">
                        {{$t('generalsetting.timezone')}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>

                        <ul>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.ag')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-switch v-model="generalsettings.ag"
                                                  :label="generalsettings.ag?'ON':'OFF'"></v-switch>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.mjafhd')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-switch v-model="generalsettings.mjafhd"
                                                  :label="generalsettings.mjafhd?'ON':'OFF'"></v-switch>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.dfh')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-select :items="listfhs" id="country" name="country"
                                                  v-model="generalsettings.dfh" solo></v-select>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.mah')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                        <v-radio-group v-model="generalsettings.mah" row>
                                            <v-radio :label="$t('generalsetting.24h')" value="24h"></v-radio>
                                            <v-radio :label="$t('generalsetting.12h')" value="12h"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </li>

                        </ul>

                        <v-row>
                            <v-spacer></v-spacer>


                            <v-btn :disbled="submitting2" style="margin-right: 2%" color="primary"
                                   @click.prevent="save(2)">

                                <span v-if='!submitting2'>{{$t('save')}} </span>
                                <span v-else><v-progress-circular
                                        :width="1"
                                        color="white"
                                        indeterminate
                                        :size="25"
                                ></v-progress-circular> {{$t('saving')}} </span>

                            </v-btn>
                        </v-row>

                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-header style="color: #29B3A6; font-weight: bold">
                        {{$t('generalsetting.privacy')}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>

                        <ul>

                            <li>
                                <v-row>
                                    <v-col md="8" sm="8" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.upt')}}
                                        <br> <a style="margin-left: 2%" target="_blank"
                                                :href="generalsettings.oldupt.substr(7)" color="primary"> Voir le
                                        fichier </a>
                                    </v-col>

                                    <v-col md="4" sm="4" style="margin: 0%; padding: 0%;">
                                        <v-file-input :rules="rules"
                                                      :label="$t('generalsetting.placeholderFile')"
                                                      id="fileinput2"
                                                      prepend-icon="mdi-paperclip" accept="application/pdf"
                                                      v-model="generalsettings.upt" single-line solo>

                                        </v-file-input>
                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="8" sm="8" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.uct')}} <br> <a style="margin-left: 2%" target="_blank"
                                                                             :href="generalsettings.olduct.substr(7)"
                                                                             color="primary"> Voir le fichier </a>
                                    </v-col>

                                    <v-col md="4" sm="4" style="margin: 0%; padding: 0%;">

                                        <v-file-input
                                                :label="$t('generalsetting.placeholderFile')"
                                                id="fileinput"
                                                prepend-icon="mdi-paperclip"
                                                accept="application/pdf"
                                                :rules="rules"
                                                v-model="generalsettings.uct" single-line solo>
                                        </v-file-input>

                                    </v-col>
                                </v-row>
                            </li>

                            <li>
                                <v-row>
                                    <v-col md="8" sm="8" style="margin-top: 0.1%;">
                                        <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.la')}}
                                    </v-col>

                                    <v-col md="4" sm="4" style="margin: 0%; padding: 0%;">

                                        <v-select :items="langues" item-text='_name' item-value="_id" return-object
                                                  v-model="generalsettings.la" solo></v-select>
                                    </v-col>

                                </v-row>
                            </li>

                        </ul>

                        <v-row>
                            <v-spacer></v-spacer>


                            <v-btn :disbled="submitting3" style="margin-right: 2%" color="primary"
                                   @click.prevent="save(3)">

                                <span v-if='!submitting3'>{{$t('save')}} </span>
                                <span v-else><v-progress-circular
                                        :width="1"
                                        color="white"
                                        indeterminate
                                        :size="25"
                                ></v-progress-circular> {{$t('saving')}} </span>

                            </v-btn>
                        </v-row>

                    </v-expansion-panel-content>
                </v-expansion-panel>

            </v-expansion-panels>


        </v-container>

        <v-snackbar
                v-model="snackbar">
            {{ text }}

            <template v-slot:action="{ attrs }">
                <v-btn
                        color="primary"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                        right
                        top
                >
                    {{$t("close")}}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {IntegerPlusminus} from 'vue-integer-plusminus'


    export default {
        name: "GeneralSetting",
        components: {IntegerPlusminus},
        data() {
            return {
                snackbar: false,
                rules: [
                    value => !value || value.size < 2000000 || this.getErrorUpload()
                ],
                panel: 0,
                text: '',
                submitting: false,
                submitting2: false,
                submitting3: false,
                submitting4: false,
                accordion: true,
                popout: false,
                inset: false,
                multiple: false,
                disabled: false,
                readonly: false,
                focusable: true,
                flat: false,
                hover: true,
                tile: true,
                generalsettings: {
                    rapwf: false,
                    nevc: 1,
                    nmcpw: 1,
                    aucpw: false,
                    dpm: false,
                    dpb: false,
                    dpqr: false,
                    erpw: false,
                    ag: false,
                    mjafhd: false,
                    dfh: "UTC+01:00",
                    mah: "24h",
                    upt: "Vide",
                    uct: "Vide",
                    oldupt: "Vide",
                    olduct: "Vide",
                    la: "fr",
                    mminr: 0,
                    mmint: 0,
                    mmintr: 0,
                    mminrch: 0,
                    mmaxr: 0,
                    mmaxt: 0,
                    mmaxtr: 0,
                    mmaxrch: 0,
                    tt: 0,
                    dda: 0,
                },
                listfhs: [
                    "UTC+00:00",
                    "UTC+01:00",
                    "UTC+02:00",
                    "UTC+03:00",
                    "UTC+03:30",
                    "UTC+04:00",
                    "UTC+04:30",
                    "UTC+05:00",
                    "UTC+05:30",
                    "UTC+05:45",
                    "UTC+06:00",
                    "UTC+06:30",
                    "UTC+07:00",
                    "UTC+07:30",
                    "UTC+08:00",
                    "UTC+08:30",
                    "UTC+08:45",
                    "UTC+09:00",
                    "UTC+09:30",
                    "UTC+10:00",
                    "UTC+10:30",
                    "UTC+11:00",
                    "UTC+11:30",
                    "UTC+12:00",
                    "UTC+12:45",
                    "UTC+13:00",
                    "UTC+13:45",
                    "UTC+14:00"
                ],
                errors: undefined
            }
        },
        computed: {
            ...mapState('generalsettings/', ['generals']),
            ...mapState('langues/', ['langues']),
            ...mapState('devises/', ['devises'])
        },
        mounted() {

            this.$store.dispatch('generalsettings/getGeneralSetting').then(response => {
                console.log('getGeneralSetting', response);
                this.generalsettings = response.generalsettings;
                this.generalsettings.oldupt = response.generalsettings.upt;
                this.generalsettings.olduct = response.generalsettings.uct;
            });

            this.$store.dispatch('langues/getLangues').then(response => {
                console.log(response)
            });
            this.$store.dispatch('devises/getDevises').then(response => {
                window.console.log('devises', response)
            });
        },
        methods: {

            getErrorUpload() {
                return this.$t('generalsetting.sizePdfFile');
            },
            loadsub(pos, state) {
                switch (pos) {
                    case 1:
                        this.submitting = state;
                        break;

                    case 2:
                        this.submitting2 = state;
                        break;

                    case 3:
                        this.submitting3 = state;
                        break;

                    case 4:
                        this.submitting4 = state;
                        break;


                }
            },

            save(pos) {
                this.loadsub(pos,true);

                let data = new FormData();
                try {
                    this.generalsettings.la = this.generalsettings.la._id;
                    if (this.generalsettings.dda._id) {
                        this.generalsettings.dda = this.generalsettings.dda._id;
                    }
                } catch (e) {
                    console.log(e);
                }
                data.append("generalsettings", JSON.stringify(this.generalsettings));
                data.append("upt", this.generalsettings.upt);
                data.append("uct", this.generalsettings.uct);
                if (pos == 3) {
                    var input = document.getElementById('fileinput');
                    var file = input.files[0];

                    var input2 = document.getElementById('fileinput2');
                    var file2 = input2.files[0];


                    console.log("File " + file.name + " is " + file.size + " bytes in size");
                    if (this.generalsettings.uct.name) {
                        if (this.generalsettings.uct.name.split('.').pop() != "pdf") {
                            this.loadsub(pos, false);
                            this.snackbar = true;
                            this.text = this.$t("generalsetting.errorfilepdf");
                            return 0;
                        } else {
                            if (file.size > 2000000) {
                                this.loadsub(pos, false);
                                this.snackbar = true;
                                this.text = this.$t("generalsetting.sizePdfFile");
                                return 0;
                            }
                        }
                    }

                    if (this.generalsettings.upt.name) {
                        if (this.generalsettings.upt.name.split('.').pop() != "pdf") {
                            this.loadsub(pos, false);
                            this.snackbar = true;
                            this.text = "Fichier PDF requis";
                            return 0;
                        } else {
                            if (file2.size > 2000000) {
                                this.loadsub(pos, false);
                                this.snackbar = true;
                                this.text = this.$t("generalsetting.sizePdfFile");
                                return 0;
                            }
                        }
                    }
                }
                 let mineroute = 'generalsettings/updateGeneralSetting';
                  this.$store.dispatch(mineroute, data).then((response) => {
                      console.log("response",response);
                      this.loadsub(pos, false);
                      this.snackbar = true;
                      this.text = response.data.message;
                      if(!response.data.error)
                      {
                          this.generalsettings = response.data.generalsettings;
                          this.generalsettings.oldupt = response.data.generalsettings.upt;
                          this.generalsettings.olduct = response.data.generalsettings.uct;
                      }

                  })
            },
        },
    }

</script>

<style scoped>
    ul {
        font-size: 12pt;

        list-style-type: none;
    }

    li {
        margin-top: 1.8%;
    }


</style>
